export const environment = {
  production: false,
  apiUrl: 'https://api.workspace-dev.pragetx.ai/api',
};
